/**
* @author Algirdas Noreika, Indeform Ltd
* @copyright Copyright 2018, Indeform Ltd. DO NOT EDIT WITHOUT PERMISSION.
* @version 20181004
* @description UI Component base class.
*/


import UI from "./ui";


class Component {
    static $ID(id) { return UI.$ID(id); }

    get core() { return this._core; }
    get ui() { return this._ui; }
    static get ELMID_BODY() { return null; }

    constructor(ui, elmId, events, params = {}) {
        this._ui = ui;
        this._core = ui.core;

        this.elmId = elmId;
        this.elm = ( elmId === Component.ELMID_BODY ? document.body : UI.$ID(elmId) );
        this.events = events;
        this.params = params;

        this.elmDestination = ( params.elmDestination === undefined ? this.elm : UI.$ID(params.elmDestination) );
        this.cssClasses = ( params.cssClasses === undefined ? {} : params.cssClasses )
        this.listener = null;
        this._states = {};
    }


    dispose() {
        this.deactivateEventsHandling();

        this._ui = undefined;
        this._core = undefined;

        this.elmId = undefined;
        this.elm = undefined;
        this.events = undefined;
        this.params = undefined;

        this.listener = undefined;
    }


    isAttachedToElement() { return (this.elm !== null); }


    isElementMatching(comp) { return this.elm === comp.elm; }


    activateEventsHandling() {
        if (this.elm === null) return;

        this.listener = this.handleEvent.bind(this);

        for (let i = 0, n = this.events.length; i < n; i++) {
            this.elm.addEventListener(this.events[i], this.listener);
        }
    }


    deactivateEventsHandling() {
        if(this.elm === null) return;

        for (let i = 0, n = this.events.length; i < n; i++) {
            this.elm.removeEventListener(this.events[i], this.listener);
        }

        this.listener = null;
    }


    handleEvent(e) {
        //e.stopPropagation();
        const action = e.target.dataset.act === undefined ? null : e.target.dataset.act;
        const data = e.target.dataset.actd === undefined ? null : e.target.dataset.actd;

        let parsedData = {};

        if (data !== null && data !== "") {
            try {
                parsedData = JSON.parse( data.replace(/[']/g, '"') );
            } catch(e) {
                console.warn(e);
            }
        }


        let fn = "on_";
        let fnExtended = fn;

        if (action != null) {
            fn += action;
            fnExtended = fn + "_" + e.type;
        } else {
            fn += e.type;
            fnExtended = fn;
        }


        if (this[fnExtended] !== undefined && typeof this[fnExtended] === "function") this[fnExtended](parsedData, e);
        else if (this[fn] !== undefined && typeof this[fn] === "function") this[fn](parsedData, e);
    }


    // default functions.
    on_locate(data, e) {
        this.locate(data.url);
        if (this.core.history) this.core.history.push({url: data.url}, '/');
    }


    on_submit(data, e) {
        e.preventDefault();
        this.submit(e.target);
    }


    locate(url, update = true, callback = null) {
        this.core.net.get({url: url, data: null, isJson: false})
        .then((data) => {
            this.elmDestination.innerHTML = data;
            if (update) this.ui.update();
            if (callback !== null) callback(data);
        })
        .catch((e) => console.log(e));
    }



    submit(form, callback = null) {
        console.log("SUBMIT:", form);

        let formData = {};

        let elm = form.elements;

        for(let i = 0, n = elm.length; i < n; i++) {
            if(elm[i].type === "checkbox" || elm[i].type === "radio") {
                if(elm[i].checked) {
                    formData[elm[i].name] = elm[i].value;
                }
            }
            else {
                formData[elm[i].name] = elm[i].value;
            }
        }

        let header = {
            'key': 'X-CSRFToken',
            'value': csrfToken
        };

        this.core.net.post({url: form.action, data: formData, headers: [header], isJson: false, serialize: true})
            .then((data) => {
                this.elmDestination.innerHTML = data;
                this.ui.update();
                if (callback !== null) callback(data);
            }).catch((e) => console.log(e));
    }


    setState(keys, state) {
        if (Array.isArray(keys)) {
            for(var i = 0, n = keys.length; i < n; i++) {
                this._states[keys[i]] = state;
            }
        } else if (keys != null) {
            this._states[keys] = state;
        } else {
            for(let key in this._states) {
                this._states[key] = state;
            }
        }
    }

    isState(key) { return this._states[key]; }


//     show(isVisible = true) {
//         if (isVisible) {
//             this.elm.classList.remove('hidden');
//         } else {
//             this.elm.classList.add('hidden');
//         }
//         // if (isVisible) {
//         //     this.elm.style.display = "block";
//         // } else {
//         //     this.elm.style.display = "none";
//         // }
//
// /*
//         this.elm.classes.add();
//         this.elm.classes.remove();
//         this.cssClasses.cssShow.add
//             this.elm.classList.add(this.cssClasses);
//
//
//         }
//         */
//     }

    show(options = {isVisible: true, isAnimated: false}) {
        if (options.hasOwnProperty('isAnimated') && options.isAnimated) {
            if (options.isVisible || options.isVisible === undefined) {
                this.elm.classList.remove('anim-hidden');
            } else {
                this.elm.classList.add('anim-hidden');
            }
            return;
        }

        if (options.isVisible || options.isVisible === undefined) {
            this.elm.classList.remove('hidden');
        } else {
            this.elm.classList.add('hidden');
        }
    }


    isVisible(value) {
        return !this.elm.classList.contains('hidden') && !this.elm.classList.contains('anim-hidden');
        // return this.elm.style.display == "block";
    }

    isObjEmpty(obj) {
        return Object.keys(obj).length === 0 && obj.constructor === Object;
    }
}

export { Component }
export default Component
